module.exports = __webpack_public_path__ + "Linearicons-Free.03e91f122aa5fd425abb";


//////////////////
// WEBPACK FOOTER
// F:/SVNNew/Web/Phoenix HealthCare/HealthCare_UI/src/assets/vendors/by_hands/font-linearicons/fonts/Linearicons-Free.woff2?w118d
// module id = ../../../../../src/assets/vendors/by_hands/font-linearicons/fonts/Linearicons-Free.woff2?w118d
// module chunks = styles